mutation updateCompanyRegion($input: UpdateCompanyRegionInput!) {
  updateCompanyRegion(input: $input)
}
